// Vertical space reserved for the modal's top offset/margin, outside its body.
// Shared with InspectionMediaModal's getVideoModalWidth, which sizes portrait
// video modals to fit the same available viewport height.
export const MODAL_VERTICAL_OFFSET = 25;
